import i18n from '@/i18n'
import AsideMenuLayout from '../layout/asideMenuLayout.vue'
import { TAB_CATEGORY } from '@/constant/permission'
// import { COMPANY_ADMIN_MENU_GROUP_KEY } from '@/constant/company'
// import onboardingManagementRoute from './onboardingManagement/route'
// import onboardingInvitationRoute from './onboardingInvitation/route'
// import jobPosterManagementRoute from './jobPosterManagement/route'
// import jobPostingManagementRoute from './jobPostingManagement/route'
// import satisfactionSurveyManagementRoute from './satisfactionSurveyManagement/route'
// import postApplicantManagementRoute from './postApplicantManagement/route'
// import postApplicantInvitationRoute from './postApplicantInvitation/route'
// import openQuestionRoute from './openQuestionTemplate/route'
// import jobTemplateRoute from './jobTemplate/route'
// import auditLogRoute from './auditLog/route'
// import applicantLockRoute from './applicantLockManagement/route'
// import applicantStatusAutoChangeRoute from './applicantStatusAutoChangeManagement/route'
// import alumniManagementRoute from './alumniManagement/route'
// import companyPolicyManagement from './companyPolicyManagement/route'
// import notificationManagement from './notificationManagement/route'
// import applicationStatusNotificationTemplate from './applicantStatusNotificationTemplate/route'

// const routes = [
//   {
//     name: 'userManagement',
//     path: '/user-management',
//     component: null,
//     meta: {
//       permission: 'PERM_ADMIN_USER',
//       get title () {
//         return i18n.t('admin.company.userManagement.title')
//       },
//       menu: {
//         get label () {
//           return i18n.t('admin.company.userManagement.menu')
//         },
//         group: COMPANY_ADMIN_MENU_GROUP_KEY.COMPANY_INTERNAL
//       }
//     }
//   },
//   {
//     name: 'roleManagement',
//     path: '/role-management',
//     component: null,
//     meta: {
//       permission: 'PERM_ADMIN_ROLE',
//       get title () {
//         return i18n.t('admin.company.roleManagement.title')
//       },
//       menu: {
//         get label () {
//           return i18n.t('admin.company.roleManagement.menu')
//         },
//         group: COMPANY_ADMIN_MENU_GROUP_KEY.COMPANY_INTERNAL
//       }
//     }
//   },
//   auditLogRoute,
//   {
//     name: 'companyManagement',
//     path: '/company-management',
//     component: null,
//     meta: {
//       permission: 'PERM_ADMIN_COMPANY',
//       get title () {
//         return i18n.t('admin.company.companyManagement.title')
//       },
//       menu: {
//         get label () {
//           return i18n.t('admin.company.companyManagement.menu')
//         },
//         group: COMPANY_ADMIN_MENU_GROUP_KEY.COMPANY_INTERNAL
//       }
//     }
//   },
//   {
//     name: 'hmManagement',
//     path: '/hm-management',
//     component: null,
//     meta: {
//       permission: 'PERM_HM_MANAGERMENT',
//       get title () {
//         return i18n.t('admin.company.hmManagement.title')
//       },
//       menu: {
//         get label () {
//           return i18n.t('admin.company.hmManagement.menu')
//         },
//         group: COMPANY_ADMIN_MENU_GROUP_KEY.COMPANY_INTERNAL
//       }
//     }
//   },
//   {
//     name: 'jobLocationManagement',
//     path: '/job-location-management',
//     component: null,
//     meta: {
//       permission: 'PERM_ADMIN_COMPANY_JOB_LOCATION_MANAGE',
//       get title () {
//         return i18n.t('admin.company.jobLocationManagement.title')
//       },
//       menu: {
//         get label () {
//           return i18n.t('admin.company.jobLocationManagement.menu')
//         },
//         group: COMPANY_ADMIN_MENU_GROUP_KEY.RECRUIT
//       }
//     }
//   },
//   jobTemplateRoute,
//   openQuestionRoute,
//   {
//     name: 'interviewQuestionTemplateManagement',
//     path: '/interview-question-template-management',
//     component: null,
//     meta: {
//       permission: ['PERM_EDIT_INTERVIEW_FORM', 'PREMIUM_INTERVIEW_SCHEDULING'],
//       get title () {
//         return i18n.t('admin.company.interviewQuestionTemplateManagement.title')
//       },
//       menu: {
//         get label () {
//           return i18n.t('admin.company.interviewQuestionTemplateManagement.menu')
//         },
//         group: COMPANY_ADMIN_MENU_GROUP_KEY.RECRUIT
//       }
//     }
//   },
//   {
//     name: 'emailManagement',
//     path: '/email-management',
//     component: null,
//     meta: {
//       permission: 'PERM_EDIT_EMAIL_TEMPLATE',
//       get title () {
//         return i18n.t('admin.company.emailManagement.title')
//       },
//       menu: {
//         get label () {
//           return i18n.t('admin.company.emailManagement.menu')
//         },
//         group: COMPANY_ADMIN_MENU_GROUP_KEY.CUSTOMER_BRAND
//       }
//     }
//   },
//   {
//     name: 'customMobileLandingPage',
//     path: '/custom-landing-page',
//     component: null,
//     meta: {
//       permission: ['PERM_EDIT_MOBILE_LANDING_PAGE', 'PREMIUM_CUSTOM_MOBILE_LANDING_PAGE'],
//       get title () {
//         return i18n.t('admin.company.customMobileLandingPage.title')
//       },
//       menu: {
//         get label () {
//           return i18n.t('admin.company.customMobileLandingPage.menu')
//         },
//         group: COMPANY_ADMIN_MENU_GROUP_KEY.CUSTOMER_BRAND
//       }
//     }
//   },
//   {
//     name: 'customJobDetailPage',
//     path: '/customize-job-detail-page',
//     component: null,
//     meta: {
//       permission: [
//         'PERM_CUSTOMIZE_JOB_DETAIL_PAGE',
//         'PREMIUM_CUSTOM_JOB_DETAIL',
//         'PREMIUM_CUSTOM_JOB_DETAIL_COMPANY_LEVEL'
//       ],
//       get title () {
//         return i18n.t('admin.company.customJobDetailPage.title')
//       },
//       menu: {
//         get label () {
//           return i18n.t('admin.company.customJobDetailPage.menu')
//         },
//         group: COMPANY_ADMIN_MENU_GROUP_KEY.CUSTOMER_BRAND
//       }
//     }
//   },
//   {
//     name: 'exportData',
//     path: '/company-export-data',
//     component: null,
//     meta: {
//       permission: ['PERM_COMPANY_EXPORT_DATA', 'PREMIUM_EXPORT_DATA'],
//       get title () {
//         return i18n.t('admin.company.exportData.title')
//       },
//       menu: {
//         get label () {
//           return i18n.t('admin.company.exportData.menu')
//         },
//         group: COMPANY_ADMIN_MENU_GROUP_KEY.DATA
//       }
//     }
//   },
//   {
//     name: 'elcExportData',
//     path: '/elc-export-apply-data',
//     component: null,
//     meta: {
//       permission: 'COMPUTED_COMPANY_IS_ELC',
//       get title () {
//         return i18n.t('admin.company.elcExportData.title')
//       },
//       menu: {
//         get label () {
//           return i18n.t('admin.company.elcExportData.menu')
//         },
//         group: COMPANY_ADMIN_MENU_GROUP_KEY.DATA
//       }
//     }
//   },
//   {
//     name: 'dashboard',
//     path: '/dashboard',
//     component: null,
//     meta: {
//       permission: 'PERM_DASHBOARD',
//       get title () {
//         return i18n.t('admin.company.dashboard.title')
//       },
//       menu: {
//         get label () {
//           return i18n.t('admin.company.dashboard.menu')
//         },
//         group: COMPANY_ADMIN_MENU_GROUP_KEY.DATA
//       }
//     }
//   },
//   {
//     name: 'companyData',
//     path: '/company-data',
//     component: null,
//     meta: {
//       permission: 'PERM_DASHBOARD',
//       get title () {
//         return i18n.t('admin.company.companyData.title')
//       },
//       menu: {
//         get label () {
//           return i18n.t('admin.company.companyData.menu')
//         },
//         group: COMPANY_ADMIN_MENU_GROUP_KEY.DATA
//       }
//     }
//   },
//   {
//     name: 'companyUserData',
//     path: '/company-user-data',
//     component: null,
//     meta: {
//       permission: 'PERM_DASHBOARD',
//       get title () {
//         return i18n.t('admin.company.companyUserData.title')
//       },
//       menu: {
//         get label () {
//           return i18n.t('admin.company.companyUserData.menu')
//         },
//         group: COMPANY_ADMIN_MENU_GROUP_KEY.DATA
//       }
//     }
//   },
//   {
//     name: 'candidateStatusManagement',
//     path: '/candidate-status-change-cause-management',
//     component: null,
//     meta: {
//       permission: ['PERM_CANDIDATE_STATUS_CHANGE_CAUSE_MANAGERMENT', 'PREMIUM_STATUS_CAUSE_MANAGEMENT'],
//       get title () {
//         return i18n.t('admin.company.candidateStatusManagement.title')
//       },
//       menu: {
//         get label () {
//           return i18n.t('admin.company.candidateStatusManagement.menu')
//         },
//         group: COMPANY_ADMIN_MENU_GROUP_KEY.RECRUIT
//       }
//     }
//   },
//   {
//     name: 'vendorManagement',
//     path: '/vendor-management',
//     component: null,
//     meta: {
//       permission: ['PERM_VENDOR_MANAGERMENT', 'PREMIUM_VENDOR_MANAGEMENT'],
//       get title () {
//         return i18n.t('admin.company.vendorManagement.title')
//       },
//       menu: {
//         get label () {
//           return i18n.t('admin.company.vendorManagement.menu')
//         },
//         group: COMPANY_ADMIN_MENU_GROUP_KEY.COMPANY_INTERNAL
//       }
//     }
//   },
//   {
//     name: 'customJobFilter',
//     path: '/custom-job-filter/list',
//     component: null,
//     meta: {
//       permission: ['PERM_JOB_CUSTOM_FIELD', 'PREMIUM_JOB_CUSTOM_FIELD', 'COMPUTED_COMPANY_HAS_CUSTOM_JOB_FILTER'],
//       get title () {
//         return i18n.t('admin.company.customJobFilter.title')
//       },
//       menu: {
//         get label () {
//           return i18n.t('admin.company.customJobFilter.menu')
//         },
//         group: COMPANY_ADMIN_MENU_GROUP_KEY.RECRUIT
//       }
//     }
//   },
//   {
//     name: 'weChatTemplateMessageManagement',
//     path: '/wechat-template-message-management',
//     component: null,
//     meta: {
//       permission: ['PERM_WECHAT_TEMPLATE_MESSAGE_MANAGEMENT', 'PREMIUM_WECHAT_TEMPLATE_MESSAGE'],
//       get title () {
//         return i18n.t('admin.company.weChatTemplateMessageManagement.title')
//       },
//       menu: {
//         get label () {
//           return i18n.t('admin.company.weChatTemplateMessageManagement.menu')
//         },
//         group: COMPANY_ADMIN_MENU_GROUP_KEY.CUSTOMER_BRAND
//       }
//     }
//   },
//   {
//     name: 'companyEmployeeManagement',
//     path: '/referral/company-employee-management/',
//     component: null,
//     meta: {
//       permission: ['PERM_REFERRAL_MANAGERMENT', 'COMPUTED_COMPANY_REFERRAL_ENABLED'],
//       get title () {
//         return i18n.t('admin.company.employeeManagement.title')
//       },
//       menu: {
//         get label () {
//           return i18n.t('admin.company.employeeManagement.menu')
//         },
//         group: COMPANY_ADMIN_MENU_GROUP_KEY.COMPANY_INTERNAL
//       }
//     }
//   },
//   onboardingManagementRoute,
//   onboardingInvitationRoute,
//   jobPosterManagementRoute,
//   jobPostingManagementRoute,
//   satisfactionSurveyManagementRoute,
//   postApplicantManagementRoute,
//   postApplicantInvitationRoute,
//   {
//     name: 'companyCashManagement',
//     path: '/referral/cash-management/',
//     component: null,
//     meta: {
//       permission: ['PERM_REFERRAL_COMPANY_BALANCE_MANAGEMENT', 'COMPUTED_COMPANY_REFERRAL_ENABLED'],
//       get title () {
//         return i18n.t('admin.company.cashManagement.title')
//       },
//       menu: {
//         get label () {
//           return i18n.t('admin.company.cashManagement.menu')
//         },
//         group: COMPANY_ADMIN_MENU_GROUP_KEY.REFERRAL
//       }
//     }
//   },
//   {
//     name: 'companyPointsManagement',
//     path: '/referral/points-management/',
//     component: null,
//     meta: {
//       permission: ['PERM_REFERRAL_COMPANY_BALANCE_MANAGEMENT', 'COMPUTED_COMPANY_REFERRAL_ENABLED', 'PREMIUM_REFERRAL_POINTS_REWARDS'],
//       titleI18nKey: 'admin.company.pointsManagement.title',
//       menu: {
//         get label () {
//           return i18n.t('admin.company.pointsManagement.menu')
//         },
//         group: COMPANY_ADMIN_MENU_GROUP_KEY.REFERRAL
//       }
//     }
//   },
//   {
//     name: 'companySourceChannelManagement',
//     path: '/company-source-channel/',
//     component: null,
//     meta: {
//       permission: ['PERM_COMPANY_SOURCING_CHANNEL_MANAGEMENT'],
//       titleI18nKey: 'admin.company.sourceChannelManagement.title',
//       menu: {
//         get label () {
//           return i18n.t('admin.company.sourceChannelManagement.menu')
//         },
//         group: COMPANY_ADMIN_MENU_GROUP_KEY.RECRUIT
//       }
//     }
//   },
//   applicantLockRoute,
//   applicantStatusAutoChangeRoute,
//   alumniManagementRoute,
//   notificationManagement,
//   applicationStatusNotificationTemplate,
//   companyPolicyManagement,
//   {
//     name: 'jobBoardPointDashboardManagement_old',
//     path: '/v-admin/job-post/record',
//     redirect: '/v-admin/company-admin/job-board-point-dashboard',
//     component: null,
//     meta: {
//       permission: ['PREMIUM_JOB_BOARD_POINT_DASHBOARD', 'PERM_HR_JOB_BOARD_POINT_DASHBOARD'],
//       titleI18nKey: 'admin.company.jobBoardPointDashboard.title.index',
//       menu: {
//         get label () {
//           return i18n.t('admin.company.jobBoardPointDashboard.menu.index')
//         },
//         hiddenInNewLayout: true,
//         group: COMPANY_ADMIN_MENU_GROUP_KEY.RECRUIT
//       }
//     }
//   }
// ]

const companyAdminRoute = {
  name: 'companyAdminLayout',
  path: '/company-admin-entrance',
  redirect: '/v-admin/company-admin',
  component: AsideMenuLayout,
  meta: {
    isInclude: true,
    permission: TAB_CATEGORY.COMPANY_ADMIN,
    get title () {
      return i18n.t('admin.company.title')
    },
    tab: {
      get label () {
        return i18n.t('admin.company.tab')
      }
    }
  },
  children: []
}

export default companyAdminRoute
